import { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { GlobalContext } from "../context/GlobalContext";
import api from "components/settings/api";

import ModalErrorHandler from "./ModalErrorHandler";
import { toast, Bounce } from "react-toastify";
import CustomToastMessage from "../common/CustomToastMessage";
import { Button } from "@mui/material";
import { makeStyles } from'@mui/styles';
import { useAuth } from "components/context/auth";

const useStyles = makeStyles({
  sendButton: {
    width: "119px",
    height: "40px",
    backgroundColor: "#2eb790",
    color: "#fff",
    float: "right",
    marginBottom: "7px"
  },
});

const ApplicationMessage =
  "Why do you want to join this team? Send a brief message to the managers of the team explaining your qualifications.";
const SubmitApplicationLetter = ({
  teamInfo,
  variant = "apply",
  togglePreview,
}) => {
  const classes = useStyles();
  // This context comes from the GlobalContext Wrapper Component
  const appState = useContext(GlobalContext);
  const {  } = appState;
  const {user:currentUser} = useAuth()

  // State
  const [applyData, updateApplyData] = useState("");
  const [showApply, displayApplyButton] = useState(false);

  // Errors State
  const [showErrors, setShowErrors] = useState(false);
  const [errorsArr, setErrorsArr] = useState();

  // This method is called when user is type changings in inputs.
  const handleChange = (event) => {
    const { value } = event.target;
    // Update state
    updateApplyData(value);
  };

  useEffect(() => {
    // Determine if apply button should show
    const showApplyButton = () => {
      // Is the user logged in
      // Is the team status seeking new members
      // Is the variant "apply"
      if (
        currentUser !== undefined &&
        teamInfo.status === "Accepting Applications" &&
        variant === "apply"
      ) {
        displayApplyButton(true);
      } else {
        displayApplyButton(false);
      }
    };

    showApplyButton();
  }, [teamInfo, variant, currentUser]);
  // Toast message function
  const notify = (message) =>
    toast.info(<CustomToastMessage message={message} />, {
      autoClose: 2000,
      closeButton: true,
      hideProgressBar: false,
      transition: Bounce,
      position: "bottom-center",
    });

  // This method is called when the user submits the form
  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();
    }

    try {
      const payload = {
        application_letter: applyData,
        publicTeamId: teamInfo.public_team_id,
        publicId: currentUser.public_user_id,
      };

      // Make post request for new team application
      const res = await api.post("/api/v1/invites/apply", payload);

      if (res.data.validationErrors) {
        // Set errors
        setErrorsArr(res.data.validationErrors.errors);
        // Show the errors component
        setShowErrors(true);
      } else if (res.data.inviteWasCreated === false) {
        // Set error message
        setErrorsArr([
          {
            msg: "You already applied to the team.",
          },
        ]);
        // Show error
        setShowErrors(true);
      } else {
        // Clear old error messages
        setErrorsArr([]);
        // Don't show error
        setShowErrors(false);
        // Invite was successful, close modal
        togglePreview();
        // Show message
        notify("Application sent");
      }
    } catch (err) {
      throw new Error(err);
    }
  };

  return (
    <div className="wrapperApplicatiionLet">
      <div className="container--inner_modal_application">
        <div container="container--inner_modal_top">
          {showApply && (
            <div className="container--inner_modal_bottom">
              <form
                className="form--section_form-application"
                onSubmit={handleSubmit}
                method="POST"
                aria-label="Request team limit change"
              >
                <label
                  className="header header--text_label_application header--section_data_label"
                  htmlFor="applicationletter"
                >
                  {/* <h2 className="header header--modal_heading-dark">
                    Application Letter
                  </h2> */}
                  <div className="app-letter_error">
                    {showErrors && <ModalErrorHandler errorsArr={errorsArr} />}
                  </div>
                  <div className="application-message">
                    {ApplicationMessage}
                  </div>
                  <textarea
                    className="input input--form_input input--form_text_area"
                    type="text"
                    name="content"
                    placeholder="What makes you perfect for this team?"
                    row="10"
                    cols="1"
                    value={applyData}
                    onChange={handleChange}
                    minLength="1"
                    maxLength="600"
                    required
                    aria-label="Application letter"
                  />
                </label>
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <Button type="submit" className={classes.sendButton} aria-label="Send">
                    Send
                  </Button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubmitApplicationLetter;

SubmitApplicationLetter.propTypes = {
  teamInfo: PropTypes.object,
  variant: PropTypes.string,
  togglePreview: PropTypes.func,
};
